import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    debug: true,
    fallbackLng: 'uk',
    supportedLngs: ['uk', 'en'],
    load: 'languageOnly',
    ns: [],
    defaultNS: [],
    interpolation: {
      escapeValue: false,
    },
  });

i18next.on('initialized', () => {
  const detectedLang = i18next.language;
  const baseLang = detectedLang.split('-')[0].split('_')[0];
  const normalized = (baseLang === 'en') ? baseLang : 'uk';

  if (detectedLang !== normalized) {
    i18next.changeLanguage(normalized);
  }
});

export default i18next;
